'use strict';

import React from 'react';

require('styles//Footer.css');

let akorda = require('../images/banners/akorda_ru.jpg');
let parlam = require('../images/banners/parlam_ru.jpg');
let egov = require('../images/banners/egov_ru.jpg');
let minzdrav = require('../images/banners/minzdrav_ru.jpg');


class FooterComponent extends React.Component {
  render() {
    
    return (
      <div className="footer-component" id="footer">
        <ul>
        <li className="banner-links"><a href="http://www.akorda.kz/ru"><img src={akorda} alt=""></img></a></li>
        <li className="banner-links"><a href="http://www.parlam.kz/ru"><img src={parlam} alt=""></img></a></li>
        <li className="banner-links"><a href="http://egov.kz/cms/kk"><img src={egov} alt=""></img></a></li>
        <li className="banner-links"><a href="https://www.gov.kz/memleket/entities/dsm?lang=ru"><img src={minzdrav} alt=""></img></a></li>
        <li className="banner-links">
        <a href="http://top100.rambler.ru/top100/"><img src="http://counter.rambler.ru/top100.cnt?384987" alt="" width="1" height="1"></img></a>
        <a href="http://top100.rambler.ru/top100/"><img src="http://top100-images.rambler.ru/top100/banner-88x31-rambler-darkblue2.gif" alt="" width="88" height="31"></img></a><br/>
        <a href="http://top.mail.ru/jump?from=1204322"  target="top"><img src="http://d0.c6.b2.a1.top.list.ru/counter?id=1204322;t=130;rand=${rand=Math.random()}" alt="" height="40" width="88"/></a>
         </li>
        </ul>
        <div className="indent"><div className="fleft">Copyright © 2017 Medinform, Inc.</div></div>
      </div>
    );
  }
}

FooterComponent.displayName = 'FooterComponent';

// Uncomment properties you need
// FooterComponent.propTypes = {};
// FooterComponent.defaultProps = {};

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/components/FooterComponent.js